import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isTargetCollapsed';

export const fn: AppBarGuardType = (context) => context.target === 'collapsed';

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
